import React, {useState, useEffect} from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import Sidebar from "../../components/Sidebar/Sidebar";
import SidebarNew from "../../components/SidebarNew/SidebarNew";
import Navbar from "../../components/Navbar/Navbar";
import Hamburger from "../../components/SidebarNew/Hamburger";
import NavbarNew from "./NavbarNew"
import { useSelector } from "react-redux";
import "./Layout.scss";
import { Modal } from "@mui/material";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";

import {
  isJobMatch,
  setOpenJobMatches,
  setModel,
  setActiveTab,
} from "../../redux/userReducer";
import JobOptionModel from "../../components/ShiftLogs/JobOptionModel";
import JobMatches from "../../components/Common/JobMatches/JobMatches";

import useWindowDimensions from "../../components/Common/WindowDimention/windowDimention";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Layout(props) {
  let { myModel, isJobMatch, recommendedUser } = useSelector(
    (state) => state.user
  );
  let dispatch = useDispatch();
  const handleClose = () => dispatch(setModel());
  const handleJobMatchClose = () => dispatch(setOpenJobMatches());

  let navigate = useNavigate();
    const location = useLocation();
    const queryClient = useQueryClient();

    // Check if we should hide the navbar
    const shouldHideNavbar = location.pathname === '/job-details/profile';

  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const { height, width } = useWindowDimensions();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCrossOpen, setIsSidebarCrossOpen] = useState(false);

  const [isSidebarOpenNew, setIsSidebarOpenNew] = useState(false);
  const [isSidebarCrossOpenNew, setIsSidebarCrossOpenNew] = useState(false);


  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
      if (window.innerWidth > 1024) {
        setIsSidebarOpen(false);
        setIsSidebarCrossOpen(false);
      }
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

   useEffect(() => {
     if (location.pathname !== "/locum-job") {
       queryClient.removeQueries(["/api/shifts"]);
     }
   }, [location.pathname]);


const toggleSidebar = () => {
  setIsSidebarOpen((prev) => !prev);
  setIsSidebarCrossOpen(!isSidebarCrossOpen);

};

const toggleSidebarNew = () => {
  setIsSidebarOpenNew((prev) => !prev);
  setIsSidebarCrossOpenNew(!isSidebarCrossOpenNew);

};

  return (
    <div className="layout">
      {!shouldHideNavbar && width < 1025 && (
        <NavbarNew
          toggleSidebarNew={toggleSidebarNew}
          isSidebarCrossOpenNew={isSidebarCrossOpenNew}
        />
      )}
      {isSidebarOpenNew && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpenNew(false)}
        />
      )}
        {/* {width < 480 && isSidebarOpenNew ?  <SidebarNew /> : null} */}
        {width < 1025 && isSidebarOpenNew && (
  <div className="mobile-sidebar-overlay" onClick={toggleSidebarNew}>
    <div className="mobile-sidebar" onClick={(e) => e.stopPropagation()}>
      <SidebarNew onClose={toggleSidebarNew} />
    </div>
  </div>
)}

      <div className="layout-wrapper">
        {/* <div className="sidebar-container"> */}
        <div
          className={`sidebar-container ${
            width < 1024 && isSidebarOpen ? "open" : ""
          }`}
        >
          <SidebarNew />
          <p
            className="sidebar-version"
            style={{
              color: "#fff",
              fontFamily: "cursive",
              textAlign: "center",
              fontSize: "12px",
            }}
          >
            Version 3.0.19
          </p>
        </div>
        <div className="outlet-container">
          <Outlet />
        </div>
      </div>
      {/* ): ( */}

      {/* )} */}

      {/* this model will open when user wants to select one out of two job option */}

      <Modal
        open={myModel}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobOptionModel />
      </Modal>

      {/* this model will open when user requirement meets with we have in db */}
      <Modal
        open={isJobMatch}
        onClose={() => {
          handleJobMatchClose();
          dispatch(
            setActiveTab({ index: 3, locumActive: 1, LocumJobToggle: true })
          );
          navigate("/locum/open-jobs");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobMatches />
      </Modal>
    </div>
  );
}

export default Layout;
